import React, { useEffect, useState } from "react";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { useGetDatasetCategories } from "api/api-hooks/datasets-hooks";
import { T } from "services/lang/LanguageService";

interface IDatasetCategoryDropdownProps {
  // Category ID
  value?: number | null;
  onChange?: (e: number) => void;
  className?: string;
  disabled?: boolean;
}

interface DropdownItem {
  value: string | number;
  label: string;
}

function DatasetCategoryDropdown(props: IDatasetCategoryDropdownProps) {
  const [allSelections, setAllSelections] = useState<DropdownItem[]>([]);

  const query = useGetDatasetCategories();

  useEffect(() => {
    if (query.data) {
      const selections = query.data.map(
        it => ({ value: it.id, label: it.toString() }) as DropdownItem
      );
      setAllSelections(selections);
    }
  }, [query.data]);

  const onChange = (e: DropdownChangeEvent) => {
    if (props.onChange == null) return;

    props.onChange(e.target.value);
  };

  return (
    <>
      {query.error && <span>{T("error.dataset-category.something-went-wrong-with-dataset-category-dropdown")}</span>}

      {query.isLoading && !query.error && <span>{T("error.dataset-category.dataset-category-dropdown-loading")}</span>}

      {!query.isLoading && (
        <Dropdown
          placeholder={T("action.select-dataset-category")}
          className={props.className}
          value={props.value}
          options={allSelections}
          filter
          filterMatchMode="contains"
          onChange={onChange}
          optionLabel="label"
          optionValue="value"
          disabled={props.disabled}
        />
      )}
    </>
  );
}

export default DatasetCategoryDropdown;